import { useMemo } from 'react';
import { daysAgo } from '../../../helpers/days-ago';
import kebabCase from 'lodash/kebabCase';

export function Tags({
  tags,
  state,
  mandate,
  listedAt,
}) {
  if (!tags?.length) return null;

  let unifiedTags = useMemo(() => {
    let unified = [];

    if (state === `Sold`) unified.push(`Sold`);
    else if (state === `Rented`) unified.push(`Rented`);
    else if (state === `Under Offer`) unified.push(`Under Offer`);
    else if (state === `Auciton`) unified.push(`Auction`);
    else if (daysAgo(listedAt) <= 30) unified.push(`Just Listed`);

    if (mandate && mandate !== `Open`) unified.push(`${mandate} Mandate`);

    unified.push(...tags);

    return unified;
  }, [tags, state, mandate, listedAt]);

  return (
    <div className={`property-card__tags`}>
      {unifiedTags.map(tag => (
        <div key={tag} className={`property-card__tag property-card__tag_type_${kebabCase(tag)}`}>
          {tag}
        </div>
      ))}
    </div>
  );
}


